module.exports = __webpack_public_path__ + "static/partnersY-dddf01dd3e67a67146c9de5ba607d836.png";